<script lang="ts" setup>
useHead({
    bodyAttrs: {
        class: 'py-[10vh] px-6'
    },
});
</script>

<template>
  <div>
    <SiteHeader/>
    <slot/>
    <SiteLinks />
  </div>
</template>

<style scoped>

</style>